export default __webpack_public_path__ + "static/media/char_frame_bg_small.915c8fb0.png";